import { render, staticRenderFns } from "./index.vue?vue&type=template&id=899f584a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=899f584a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f584a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899f584a')) {
      api.createRecord('899f584a', component.options)
    } else {
      api.reload('899f584a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=899f584a&scoped=true", function () {
      api.rerender('899f584a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/etower/MainCont/SearchAndResults/components/TranslateDialog/index.vue"
export default component.exports